import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ProductTag from 'components/product/ProductTag/ProductTag'

import s from './ProductTags.scss'


const ProductTags = ({ className, items }) => (
  <div className={cx(s.tags, className)}>
    {
      items.filter(({ name }) => name).map(({ name, img }) => (
        <ProductTag
          key={name}
          className={s.tag}
          name={name}
          img={img}
          withTitle={false}
        />
      ))
    }
  </div>
)

ProductTags.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    img: PropTypes.string,
  })),
}


export default ProductTags
